import type { RootState } from '/business/shared/state/store';
import { EMPTY_ARRAY } from '/business/shared/state/selectors/util';
import type { RequestedInitiativeInformation } from '/business/shared/state/reducers/basket';

export default (state: RootState): RequestedInitiativeInformation[] =>
  state.basket?.meta?.reductionInitiativesRequestedInfo || EMPTY_ARRAY;
